import ModalTitle from './ModalTitle';

export default ModalTitle;
